module.exports = __webpack_public_path__ + "img/avatar-default.1694fb6d.png";